import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { useAuth } from '../../context/AuthContext';
import axiosInstance from '../../api/axiosInstance';
import './Login.css';

function Login() {
    const { login } = useAuth();
    const navigate = useNavigate();

    const [nombreUsuario,  setNombreUsuario]  = useState('');
    const [password,       setPassword]       = useState('');
    const [showPassword,   setShowPassword]   = useState(false);
    const [error,          setError]          = useState('');
    const [loading,        setLoading]        = useState(false);

    async function handleSubmit(e) {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            const { data } = await axiosInstance.post('/auth/login', { nombreUsuario, password });
            login(data);
            navigate('/');
        } catch (err) {
            const mensaje = err.response?.data?.message || 'No se pudo conectar con el servidor. Intentá de nuevo.';
            setError(mensaje);
        } finally {
            setLoading(false);
        }
    }

    return (
        <div className="login">
            <div className="login__card">
                <div className="login__brand">SweetMedical</div>
                <h1 className="login__title">Iniciar sesión</h1>

                <form className="login__form" onSubmit={handleSubmit} noValidate>
                    <div className="login__field">
                        <label className="login__label" htmlFor="nombreUsuario">
                            Usuario
                        </label>
                        <input
                            id="nombreUsuario"
                            className="login__input"
                            type="text"
                            value={nombreUsuario}
                            onChange={e => setNombreUsuario(e.target.value)}
                            autoComplete="username"
                            required
                        />
                    </div>

                    <div className="login__field">
                        <label className="login__label" htmlFor="password">
                            Contraseña
                        </label>
                        <div className="login__input-wrapper">
                            <input
                                id="password"
                                className="login__input login__input--with-icon"
                                type={showPassword ? 'text' : 'password'}
                                value={password}
                                onChange={e => setPassword(e.target.value)}
                                autoComplete="current-password"
                                required
                            />
                            <button
                                type="button"
                                className="login__pass-toggle"
                                onClick={() => setShowPassword(prev => !prev)}
                                aria-label={showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
                            >
                                {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                            </button>
                        </div>
                    </div>

                    {error && <p className="login__error" role="alert">{error}</p>}

                    <button
                        className="login__btn"
                        type="submit"
                        disabled={loading}
                    >
                        {loading ? 'Ingresando...' : 'Ingresar'}
                    </button>
                </form>

                <p className="login__footer">
                    ¿No tenés cuenta?{' '}
                    <Link to="/register" className="login__link">Registrate</Link>
                </p>
            </div>
        </div>
    );
}

export default Login;
